import { capitalize } from 'utils/capitalize'
import { IOrderedShipmentStopFragment } from '../graphql/OrderedShipmentStop'
import { getNonNull } from './getNonNull'

/**
 * @example getFormattedAddress(location) // 1234 Broadway, New York, NY 11201
 */
export const getFormattedAddress = (
  location: IOrderedShipmentStopFragment['facility']['location']
): string => {
  const { address, addressLine2, city, stateCode, zipcode } = getNonNull(location)
  const addressLine = [address, addressLine2].join(', ').trim()
  const addressAndCity = [addressLine, city].map(str => capitalize(str)).join(', ')
  return `${[addressAndCity, stateCode].join(', ')} ${zipcode}`
}
